// Infobulle de badge d'actif : survol sur desktop (pointer fin), clic sur tactile.
// Une seule ouverte à la fois. Position calee dans le viewport (pas de debordement).
class BadgeTooltip extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('[data-ref="badge-tooltip-trigger"]');
    this.content = this.querySelector('[data-ref="badge-tooltip-content"]');
    if (!this.trigger || !this.content) return;

    this.hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    this._open = () => this.open();
    this._close = () => this.close();
    this._onDocClick = (event) => {
      if (!this.contains(event.target)) this.close();
    };
    this._onKeydown = (event) => {
      if (event.key === 'Escape') {
        this.close();
        this.trigger.focus();
      }
    };
    this._onTriggerClick = (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (this.hasAttribute('data-open')) this.close();
      else this.open();
    };

    if (this.hoverCapable) {
      this.addEventListener('mouseenter', this._open);
      this.addEventListener('mouseleave', this._close);
      this.trigger.addEventListener('focus', this._open);
      this.trigger.addEventListener('blur', this._close);
    } else {
      this.trigger.addEventListener('click', this._onTriggerClick);
    }
  }

  disconnectedCallback() {
    document.removeEventListener('click', this._onDocClick);
    document.removeEventListener('keydown', this._onKeydown);
  }

  open() {
    // Une seule infobulle ouverte a la fois.
    document.querySelectorAll('badge-tooltip[data-open]').forEach((el) => {
      if (el !== this) el.close();
    });
    this.setAttribute('data-open', '');
    this.trigger.setAttribute('aria-expanded', 'true');
    this._position();
    document.addEventListener('keydown', this._onKeydown);
    if (!this.hoverCapable) {
      // Differe pour ne pas fermer sur le clic d'ouverture lui-meme.
      requestAnimationFrame(() => document.addEventListener('click', this._onDocClick));
    }
  }

  close() {
    this.removeAttribute('data-open');
    this.trigger.setAttribute('aria-expanded', 'false');
    document.removeEventListener('click', this._onDocClick);
    document.removeEventListener('keydown', this._onKeydown);
  }

  // Cale l'infobulle horizontalement pour qu'elle reste dans le viewport.
  _position() {
    const content = this.content;
    content.style.left = '0px';
    const triggerRect = this.trigger.getBoundingClientRect();
    const width = content.offsetWidth;
    const margin = 12;
    const vw = window.innerWidth;
    let left = triggerRect.left;
    if (left + width > vw - margin) left = vw - margin - width;
    if (left < margin) left = margin;
    content.style.left = left - triggerRect.left + 'px';
  }
}

if (!customElements.get('badge-tooltip')) {
  customElements.define('badge-tooltip', BadgeTooltip);
}
